import { get, postJSON, del, post } from '../utils/axios'

// 云素材列表查询
interface getSelectListProps {
    page: number //当前页
    orderBy: string //排序
    size: number //每页大小
    hot: number | string //是否热门0-否 1-是
    contentLabel: string //标签名称
}
export const getSelectList = (options?: getSelectListProps) => postJSON('cloud/inviteMaterial/selectList', options)

// 云素材內容标签统计
export const getContentLabelGroupCount = () => get('cloud/inviteMaterial/contentLabelGroupCount')

// 云素材下载
export const downloadCloudMaterialToOrg = (cloudMaterialPk: string) => post('cloud/inviteMaterial/downloadCloudMaterialToOrg', {cloudMaterialPk})

// 云素材图文内容详情
export const getSelectMaterialContent = (cloudMaterialPk: string) => get('cloud/inviteMaterial/selectMaterialContent', { cloudMaterialPk })

// 门店素材內容标签统计
export const getOrgContentLabelGroupCount = (cloudMaterial?:string) => get('org/inviteMaterial/contentLabelGroupCount', {
    cloudMaterial:cloudMaterial || ''
})

// 本门店和云素材个数统计
export const getMaterialNumber = () => get('org/inviteMaterial/materialNumber')

// 本门店素材列表查询
interface getOrgSelectListProps {
    page: number //当前页
    orderBy: string //排序
    size: number //每页大小
    hot: number | string //是否热门0-否 1-是
    contentLabel: string //标签名称
}
export const getOrgSelectList = (options?: getOrgSelectListProps) => postJSON('org/inviteMaterial/selectList', options)

// 本门店素材图文内容详情
export const getOrgSelectMaterialContent = (materialPk: string) => get('org/inviteMaterial/selectMaterialContent', { materialPk })

/**
 * 策略
 */

//本门店和云策略个数统计
export const getInviteStrategyMaterialNumber = () => get('org/inviteStrategy/materialNumber')

// 云策略服务大类统计
export const getServiceGroupCount = () => get('cloud/inviteStrategy/serviceGroupCount')

// 云策略列表查询
interface getSelectListProps {
    page: number //当前页
    orderBy: string //排序
    size: number //每页大小
    serviceTypePk: string //服务大类pk
}
export const getInviteStrategySelectList = (options?: getSelectListProps) => postJSON('cloud/inviteStrategy/selectList', options)

// 云策略下载到门店
export const downloadCloudStrategyToOrg = (cloudStrategyPk: string) => post('cloud/inviteStrategy/downloadCloudStrategyToOrg', {cloudStrategyPk})

// 门店策略服务大类统计
export const getOrgServiceGroupCount = () => get('org/inviteStrategy/serviceGroupCount')

// 门店策略列表查询
interface getOrgInviteStrategySelectListProps {
    page: number //当前页
    orderBy: string //排序
    size: number //每页大小
    serviceTypePk: string //服务大类pk
}
export const getOrgInviteStrategySelectList = (options?: getOrgInviteStrategySelectListProps) => postJSON('org/inviteStrategy/selectList', options)

// 门店邀约策略详情
export const getSelectByPk = (strategyPk:string) => get('org/inviteStrategy/selectByPk', { strategyPk })

// 门店邀约策略保存/编辑
interface ItemData {
    type: string //条件类型0-客户信息 1-车辆信息
    conditionName: string //条件名称
    fieldName: string //字段名
    queryValue: string //查询值
    queryMinValue: string //查询最小值
    queryMaxValue: string //查询最大值
    queryRule: string //查询规则: equal:等于、range：范围、like：模糊、in：批量
}

interface setSaveOrUpdateProps {
    pk: string // 门店策略PK
    materialPk: string //素材PK
    strategyName: string //策略标题
    serviceTypePk: string //邀约事项(服务大类pk)
    consumeCondition: string //消费条件(距离上次相同邀约事项满X天)
    startDate: string //有效开始日期
    endDate: string //有效截止日期
    pushStartTime: string //推送开始时间
    pushEndTime: string //推送截止时间
    repeatPush: string //重复推送 0-否 1-是
    officailAccountPush: string //公众号推送 0-否 1-是
    miniprigramPush: string //小程序推送 0-否 1-是
    smsPush: string //短信推送 0-否 1-是
    enable: string //是否有效0-否 1-是
    conditionDtos:ItemData[]
}
export const setSaveOrUpdate = (options: setSaveOrUpdateProps) => postJSON('org/inviteStrategy/saveOrUpdate', options)

// 按素材pk查询素材图文内容
interface getSelectMaterialContentByMaterialPkProps {
    inviteRecordPk: string //邀约记录pk
    materialPk: string //素材pk
    orgPk: string //门店pk
}
export const getSelectMaterialContentByMaterialPk = (options: getSelectMaterialContentByMaterialPkProps) => get('h5/selectMaterialContentByMaterialPk', options )

// 更新邀约记录感兴趣状态
interface getUpdateInterestStatusProps {
    inviteRecordPk: string //邀约记录pk
    status: string //感兴趣状态：0-否 1-是
    orgPk: string //门店pk
}
export const getUpdateInterestStatus = (options: getUpdateInterestStatusProps) => post('h5/updateInterestStatus', options)

// 更新邀约记录阅读次数+状态
interface getUpdateReadStatusProps {
    inviteRecordPk: string //邀约记录pk
    time: number | string //阅读时长
    orgPk: string //门店pk
}
export const getUpdateReadStatus = (options: getUpdateReadStatusProps) => post('h5/updateReadStatus', options)

// 查询策略邀约记录列表
interface getSelectInviteRecordListProps {
    page: number | string // 当前页
    orderBy: string //排序
    size: number | string //每页大小
    strategyPk: string //策略pk
    startTime?: string //开始日期
    endTime?: string //截止日期
    carNo?: string //车牌号
}
export const getSelectInviteRecordList = (options: getSelectInviteRecordListProps) => postJSON('org/inviteStrategy/selectInviteRecordList', options)

// 云策略产值转化排名
export const getOutputValueRank = (cloudStrategyPk: string) => get('org/inviteStrategy/outputValueRank', { cloudStrategyPk } )

// 获取小程序scheme码
interface getOpenlinkProps {
    path: string // 通过 scheme 码进入的小程序页面路径，必须是已经发布的小程序存在的页面，不可携带 query。path 为空时会跳转小程序主页
    query: string //通过 scheme 码进入小程序时的 query，最大1024个字符，只支持数字，大小写英文以及部分特殊字符：
    env_version: string //要打开的小程序版本。正式版为"release"，体验版为"trial"，开发版为"develop"，仅在微信外打开时生效
}
export const getOpenlink = (options: getOpenlinkProps) => postJSON('h5/getOpenlink', options)


/**
 * 邀约仪表台
 */

// 策略统计
interface strategyStatistiProps {
    endTime: string //查询截止日期
    startTime: string //查询开始日期
}
export const getStrategyStatisti = (options: strategyStatistiProps) => get('inviteDataReport/strategyStatisti', options )

// 转化漏斗
interface funnelConversionProps {
    endTime: string //查询截止日期
    startTime: string //查询开始日期
}
export const getFunnelConversion = (options: funnelConversionProps) => get('inviteDataReport/funnelConversion', options )

// 策略排名统计
interface strategyOutputValueRankProps {
    endTime: string //查询截止日期
    startTime: string //查询开始日期
}
export const getStrategyOutputValueRank = (options: strategyOutputValueRankProps) => get('inviteDataReport/strategyOutputValueRank', options )

// 素材统计
interface materialStatistiProps {
    endTime: string //查询截止日期
    startTime: string //查询开始日期
}
export const getMaterialStatisti = (options: materialStatistiProps) => get('inviteDataReport/materialStatisti', options )

// 策略列表查询
interface strategyListProps {
    endTime: string //查询截止日期
    startTime: string //查询开始日期
    page: number //
    orderBy: string //
    size: number
}
export const getStrategyList = (options: strategyListProps) => postJSON('inviteDataReport/strategyList', options )

// 数据仪表台进去的策略邀约记录列表
interface selectInviteRecordListProps {
    strategyPk: string //策略pk
    inivteArrivalStoreStatus: string //到店状态0-未到店 1-已到店
    page: number //
    orderBy: string //
    size: number
    startTime?: string //开始日期
    endTime?: string //截止日期
    carNo?: string //车牌号
}
export const getInviteRecordList = (options: selectInviteRecordListProps) => postJSON('inviteDataReport/selectInviteRecordList', options )

// 下次待推送客户列表
interface selectUnPushUserListProps {
    strategyPk: string //策略pk
    inivteArrivalStoreStatus: string //到店状态0-未到店 1-已到店
    page: number //
    orderBy: string //
    size: number
    startTime?: string //开始日期
    endTime?: string //截止日期
    carNo?: string //车牌号
}
export const getSelectUnPushUserList = (options: selectUnPushUserListProps) => postJSON('inviteDataReport/selectUnPushUserList', options )

// 客户统计
export const getUserStatisti = () => get('inviteDataReport/userStatisti' )

// 客户邀约统计
interface userInviteStatistiProps {
    endTime: string //查询截止日期
    startTime: string //查询开始日期
}
export const getUserInviteStatisti = (options: userInviteStatistiProps) => get('inviteDataReport/userInviteStatisti', options )


// 会员统计
export const getUserCardStatisti = () => get('inviteDataReport/userCardStatisti' )

// 会员邀约统计
interface userCardInviteStatistiProps {
    endTime: string //查询截止日期
    startTime: string //查询开始日期
}
export const getUserCardInviteStatisti = (options: userCardInviteStatistiProps) => get('inviteDataReport/userCardInviteStatisti', options )

// 车辆统计
export const getUserCarStatisti = () => get('inviteDataReport/userCarStatisti' )

// 车辆邀约统计
interface userCarInviteStatistiProps {
    endTime: string //查询截止日期
    startTime: string //查询开始日期
}
export const getUserCarInviteStatisti = (options: userCarInviteStatistiProps) => get('inviteDataReport/userCarInviteStatisti', options )

// 按邀约条件查询客户列表
interface Item {
    pk?: string | number //主键
    orgPk?: string | number //组织pk
    strategyPk?: string | number //门店邀约策略PK
    type?: string | number //条件类型0-客户信息 1-车辆信息
    conditionName?: string //条件名称
    fieldName?: string //字段名
    queryValue?: string //查询值
    queryValueName?: string //查询值显示名称
    queryMinValue?: string //查询最小值
    queryMaxValue?: string //查询最大值
    queryRule?: string //查询规则: equal:等于、range：范围、like：模糊、in：批量
}

interface getUserSelectUserListProps {
    orgPk?: string 
    conditionList: Item[]
    repeatPush?: string //是否重复推送0-否 1-是
    consumeCondition?: string | number //同服务消费满X天
}
export const getUserSelectUserList = (options:getUserSelectUserListProps) => postJSON('org/inviteStrategy/selectUserList', options)

// 素材內容标签统计
interface materialContentLabelCountProps {
    startTime?: string 
    endTime?: string 
    cloudMaterial:number | string //是否云素材 0-否 1-是
}
export const getMaterialContentLabelCount = (options:materialContentLabelCountProps) => postJSON('inviteDataReport/materialContentLabelCount', options)

// 素材內容标签统计
interface materialListProps {
    page: number //当前页
    orderBy: string //排序
    size: number //每页大小
    hot: number | string //是否热门0-否 1-是
    contentLabel: string //标签名称
    cloudMaterial:number | string //是否云素材 0-否 1-是
    startTime?: string 
    endTime?: string 
}
export const getMaterialList = (options:materialListProps) => postJSON('inviteDataReport/materialList', options)

// 保存邀约素材浏览记录
interface saveBrowseRecordsProps {
    orgPk: string //门店pk
    inviteRecordPk: string //邀约记录pk
    times?: number | string //浏览时长
    lng?: string //经度
    lat?: string //纬度
    viewAddress?:string //地理位置
}
export const saveBrowseRecords = (options:saveBrowseRecordsProps) => postJSON('h5/saveBrowseRecords', options)

// 云邀约策略详情
export const getInviteStrategySelectByPk = (cloudStrategyPk:string) => get('cloud/inviteStrategy/selectByPk', { cloudStrategyPk })